import { CsprMarketEntryPoint, Deploy } from '@block-explorer/entities';
import { MessageData } from './types';
import {
  getNftTokensQuantityFromArgs,
  guardedDeriveSplitDataFromArguments,
} from './utils';

const prepareActionMessageData = (
  deploy: Deploy,
  getPublicKeyByAccountHash: (hash: string) => any,
  t
): MessageData => {
  const { entryPoint, args } = deploy;

  const entryPointName = entryPoint?.name || '';
  const actionName: Record<CsprMarketEntryPoint, string> = {
    [CsprMarketEntryPoint.delist_token]: t('Delist'),
    [CsprMarketEntryPoint.list_token]: t('List'),
    [CsprMarketEntryPoint.accept_offer]: t('Accept offer'),
    [CsprMarketEntryPoint.cancel_offer]: t('Cancel offer'),
    [CsprMarketEntryPoint.make_offer]: t('Make offer'),
    [CsprMarketEntryPoint.buy_token]: t('Buy token'),
  };

  const offererHash = guardedDeriveSplitDataFromArguments(
    args.offerer,
    'Account'
  );
  const numOfTokens =
    (entryPointName === 'list_token' || entryPointName === 'delist_token') &&
    getNftTokensQuantityFromArgs(args);

  const actionOutcome: Partial<MessageData> = {
    ...(numOfTokens && { numOfTokens: numOfTokens }),
    ...(offererHash?.hash && {
      prefix1: t('from'),
      account1: {
        accountHash: offererHash?.hash,
        publicKey: getPublicKeyByAccountHash(offererHash?.hash),
      },
    }),
  };

  return {
    entryPointName: entryPointName,
    actionName: actionName[entryPointName] || entryPointName,
    ...actionOutcome,
  };
};

export const csprMarkerMessage = () => {
  const getRelevantAccountHashesFromArgs = () => {
    return ['offerer'];
  };

  return {
    prepareActionMessageData,
    getRelevantAccountHashesFromArgs,
  };
};
